<template>
  <div>
    <base-header class="pb-6">
      <b-row align-v="center" class="py-4">
        <b-col lg="6" cols="7">
          <!-- <h6 class="h2 text-white d-inline-block mb-0">{{ motorbike._name }}</h6> -->
          <nav aria-label="breadcrumb" class="d-none d-md-inline-block">
            <route-bread-crumb></route-bread-crumb>
          </nav>
        </b-col>
        <!-- <b-col lg="6" cols="5" class="text-right">
          <base-button size="sm" type="neutral">Filters</base-button>
        </b-col> -->
      </b-row>
    </base-header>
    <b-container fluid class="mt--5">
      <div class="card mb-4">
        <!-- Card header -->
        <div class="card-header">
          <h3 class="mb-0">Motorbike details</h3>
        </div>
        <!-- Card body -->
        <div class="card-body">
          <b-form @submit.prevent="onSaveForm">
          <b-row>
            <b-col>
              <b-row><b-col><h5>Motorbike</h5></b-col></b-row>
              <b-row>
                <b-col lg="12">
                  <div class="form-group">
                    <label class="form-control-label" for="brand">Brand</label>
                    <input type="text" class="form-control" id="brand" placeholder="Brand" v-model="model.brand">
                  </div>
                </b-col>
                <b-col lg="12">
                  <div class="form-group">
                    <label class="form-control-label" for="model">Model</label>
                    <input type="text" class="form-control" id="model" placeholder="Model" v-model="model.model">
                  </div>
                </b-col>
                <b-col lg="12">
                  <div class="form-group">
                    <label class="form-control-label" for="color">Color</label>
                    <input type="text" class="form-control" id="color" placeholder="Color" v-model="model.color">
                  </div>
                </b-col>
                <b-col lg="12">
                  <div class="form-group">
                    <label class="form-control-label" for="cc">CC</label>
                    <input type="number" class="form-control" id="cc" placeholder="CC" v-model="model.cc">
                  </div>
                </b-col>
                <b-col lg="12">
                  <div class="form-group">
                    <label class="form-control-label" for="licenseplate">Licenseplate</label>
                    <input type="text" class="form-control" id="licenseplate" placeholder="Licenseplate" v-model="model.licenseplate">
                  </div>
                </b-col>
              </b-row>
            </b-col>
            <b-col>
              <b-row><b-col><h5>Acquisition</h5></b-col></b-row>
              <b-row>
                <b-col lg="12">
                  <div class="form-group">
                    <label class="form-control-label" for="acquisitionDate">Acquisition date</label>
                    <input type="date" class="form-control" id="acquisitionDate" placeholder="Acquisition date" v-model="model.acquisitionDate">
                  </div>
                </b-col>
                <b-col lg="12">
                  <div class="form-group">
                    <label class="form-control-label" for="acquisitionKm">Acquisition mileage</label>
                    <input type="number" class="form-control" id="acquisitionKm" placeholder="Acquisition mileage" v-model="model.acquisitionKm">
                  </div>
                </b-col>
                <b-col lg="12">
                  <div class="form-group">
                    <label class="form-control-label" for="acquisitionProvider">Acquisition provider</label>
                    <input type="text" class="form-control" id="acquisitionProvider" placeholder="Acquisition provider" v-model="model.acquisitionProvider">
                  </div>
                </b-col>
                <b-col lg="12">
                  <div class="form-group">
                    <label class="form-control-label" for="acquisitionPrice">Acquisition price</label>
                    <input type="number" step="any" class="form-control" id="acquisitionPrice" placeholder="Acquisition price" v-model="model.acquisitionPrice">
                  </div>
                </b-col>
                <b-col lg="12">
                  <div class="form-group">
                    <label class="form-control-label" for="firstRegistrationDate">First registration date</label>
                    <input type="date" class="form-control" id="firstRegistrationDate" placeholder="First registration date"
                      v-model="model.firstRegistrationDate">
                  </div>
                </b-col>
              </b-row>
            </b-col>
          </b-row>
          <b-row>
            <b-col class="text-right">
              <base-button type="primary" native-type="submit" class="my-4" :disabled="!hasChanges">Save</base-button>
            </b-col>
          </b-row>
          </b-form>
        </div>
      </div>
    </b-container>
  </div>
</template>
<script>
  import RouteBreadCrumb from '@/components/Breadcrumb/RouteBreadcrumb';
  import StatsCard from '@/components/Cards/StatsCard';
  import { mapActions, mapGetters } from 'vuex';

  export default {
    name: 'starter-page',
    components: {
      StatsCard,
      RouteBreadCrumb
    },
    data() {
      return {
        model: {}
      };
    },
    methods: {
      ...mapActions({
        createMotorbike: 'motorbikes/create'
      }),
      async onSaveForm() {
        const acquisitionDate = this.model.acquisitionDate && this.model.acquisitionDate.fromInputDateFormatToDate().toISOString()
        const firstRegistrationDate = this.model.firstRegistrationDate && this.model.firstRegistrationDate.fromInputDateFormatToDate().toISOString()
        const body = {
          ...this.model,
          ...(acquisitionDate && { acquisitionDate }),
          ...(firstRegistrationDate && { firstRegistrationDate })
        }

        await this.createMotorbike(body)
        this.$router.push({ name: 'motorbike', params: {id: this.motorbike.id}})
      }
    },
    computed: {
      hasChanges () {
        let changes = 0
        const keys = [
          'acquisitionDate',
          'acquisitionKm',
          'acquisitionProvider',
          'acquisitionPrice',
          'brand',
          'cc',
          'color',
          'licenseplate',
          'model',
          'firstRegistrationDate'
        ]
        Object.keys(this.model).filter(k => keys.indexOf(k) > -1).forEach(key => {
          if (this.motorbike[key] !== this.model[key]) {
            changes++
          }
        })
        return !!(changes)
      },
      ...mapGetters({
        motorbike: 'motorbikes/motorbike'
      })
    }
  };
</script>
<style>
  .starter-page {
    min-height: calc(100vh - 380px);
  }
</style>
